import { purry } from './purry';
export function clamp() {
  return purry(_clamp, arguments);
}

function _clamp(value, limits) {
  if (limits.min != null) {
    if (limits.min > value) {
      return limits.min;
    }
  }

  if (limits.max != null) {
    if (limits.max < value) {
      return limits.max;
    }
  }

  return value;
}